/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorUpdateCompositionsByIdMutationRequest, VideoEditorUpdateCompositionsByIdMutationResponse, VideoEditorUpdateCompositionsByIdPathParams, VideoEditorUpdateCompositionsById401, VideoEditorUpdateCompositionsById403 } from "../models/VideoEditorUpdateCompositionsById";

export function getVideoEditorUpdateCompositionsByIdUrl(id: VideoEditorUpdateCompositionsByIdPathParams["id"]) {
  const res = { method: 'PATCH', url: `/video-editor/v1/compositions/${id}` as const }
  return res
}

/**
 * @summary Update a single Composition
 * {@link /video-editor/v1/compositions/:id}
 */
export async function videoEditorUpdateCompositionsById(id: VideoEditorUpdateCompositionsByIdPathParams["id"], data: VideoEditorUpdateCompositionsByIdMutationRequest, config: Partial<RequestConfig<VideoEditorUpdateCompositionsByIdMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<VideoEditorUpdateCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorUpdateCompositionsById401 | VideoEditorUpdateCompositionsById403>, VideoEditorUpdateCompositionsByIdMutationRequest>({ method : "PATCH", url : getVideoEditorUpdateCompositionsByIdUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}